import React, { type FC } from 'react';

import { InlineCommentsProvider } from '@confluence/comment-context';

export const CommentContextWrapper: FC<{ children?: React.ReactNode }> = ({ children }) => {
	return <InlineCommentsProvider>{children}</InlineCommentsProvider>;
};
